import * as yup from 'yup';
import { TrustedContactDTO } from '../../AccountOpening.meta';

export const nullTrustedContactInfo: Omit<TrustedContactDTO, 'country'> = {
  legalFirstName: null,
  legalLastName: null,
  email: null,
};

const legalFirstName = yup
  .string()
  .nullable()
  .when('hasTrustedContact', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('First Name is required'),
  });

const legalLastName = yup
  .string()
  .nullable()
  .when('hasTrustedContact', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('Last Name is required'),
  });

export const email = yup
  .string()
  .nullable()
  .when('hasTrustedContact', {
    is: true,
    then: yup
      .string()
      .email('Email must be valid')
      .nullable()
      .required('Email is required'),
  });

export const trustedContactInfoValidation = yup
  .object()
  .nullable()
  .shape({
    legalFirstName,
    legalLastName,
    email,
  });
